import AdRoutes from '@/modules/MasjidImage/Ad/router.js'
import ScreenRoutes from '@/modules/MasjidImage/Screen/router.js'
const Index = () => import(/* webpackChunkName: "expense" */ './index.vue');
const Main = () => import(/* webpackChunkName: "expense" */ './views/Main.vue');

let routes = [];
routes = routes.concat(ScreenRoutes);
routes = routes.concat(AdRoutes);
routes = routes.concat([{
  path: 'main',
  name: 'user-views-main',
  component: Main,
},
]);

export default [
  {
    path: '/tvAdware',
    component: Index,
    redirect: { name: 'user-views-main' },
    children: routes,
    
  },
]
